import axios from "axios";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast, ToastContainer } from "react-toastify";

const Contact = () => {
  const { t } = useTranslation();

  const initialForm = {
    form_name: "",
    form_email: "",
    form_message: "",
  };

  const [FormUser, setFormUser] = useState(initialForm);

  const inputHandler = (event) => {
    const { name, value } = event.target;
    setFormUser((prevFormUser) => ({
      ...prevFormUser,
      [name]: value,
    }));
  };

  const submitForm = async (e) => {
    e.preventDefault();

    // Basic validation
    if (
      !FormUser.form_name.trim() ||
      !FormUser.form_email.trim() ||
      !FormUser.form_message.trim()
    ) {
      toast.error("Please fill in all the fields.");
      return;
    }

    try {
      const response = await axios.post(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/add_contact_form",
        FormUser,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("API response:", response.data);

      if (response.data.success === 1) {

  // Google Ads Conversion Tracking
  if (window.gtag) {
    window.gtag("event", "conversion", {
      send_to: "AW-18129150774/A8pNCNmU3qUcELbG08RD",
      value: 1.0,
      currency: "INR",
    });
  }

  toast.success(response.data.message || "Message submitted successfully!");
  setFormUser(initialForm);
} else {
        toast.error("Submission failed!");
      }
    } catch (error) {
      console.error("Submission error:", error);
      toast.error("Something went wrong!");
    }
  };


  // contact details 
   const [ContactDetail, setContactDetail] = useState([]);
    useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/contact_info_list"
      );
      setContactDetail([response.data.data]);
    };

    fetchData();
  }, []);


  return (
    <div>
      <section className="contact-section spad">
        <div className="container">
          <div className="row">
            {/* Contact Info Section */}
            <div className="col-lg-4">
              <div className="contact-text">
                <h1 style={{fontSize:"40px"}}>{t("contactInfo")}</h1>
                <table>
                 <tbody>
                  {ContactDetail.map((Data, index) => (
                    <tr key={index}>
                      <tr>
                      <td className="c-o contact-head">Address</td>
                      <td className="address">
                        {Data.cont_address}
                      </td>
                    </tr>
                    <tr>
                      <td className="c-o">E-mail:</td>
                      <td className="email-desc">{Data.cont_email}</td>
                    </tr>
                       <tr>
                      <td className="c-o">LandLine:</td>
                      <td>{Data.cont_landline}</td>
                    </tr>
                    <tr>
                      <td className="c-o">Phone:</td>
                      <td>{Data.cont_phone}</td>
                    </tr>
                       <tr>
                      <td className="c-o">Whatsapp No:</td>
                      <td>{Data.cont_whatsapp}</td>
                    </tr>
                    </tr>
                  ))}
                </tbody>

                </table>
              </div>
            </div>

            {/* Contact Form Section */}
            <div className="col-lg-7 offset-lg-1">
              <form onSubmit={submitForm} className="contact-form">
                <div className="row">
                  <div className="col-lg-6">
                    <input
                      type="text"
                      id="form_name"
                      name="form_name"
                      value={FormUser.form_name}
                      onChange={inputHandler}
                      placeholder={t("namePlaceholder")}
                    />
                  </div>
                  <div className="col-lg-6">
                    <input
                      type="email"
                      id="form_email"
                      name="form_email"
                      value={FormUser.form_email}
                      onChange={inputHandler}
                      placeholder={t("emailPlaceholder")}
                    />
                  </div>
                  <div className="col-lg-12">
                    <textarea
                      id="form_message"
                      name="form_message"
                      value={FormUser.form_message}
                      onChange={inputHandler}
                      placeholder={t("messagePlaceholder")}
                    />
                  </div>
                  <div className="col-lg-12">
                    <button type="submit" className="site-btn">
                      {t("submitButton") || "Submit"}
                    </button>
                  </div>
                </div>
              </form>
            </div>

          </div>
        </div>
      </section>
      <ToastContainer/>
    </div>
  );
};

export default Contact;
